<template>

            <div class="card card-2">
                <div class="card-heading">

                  <div class="account-erstellen2">
                    {{ $t("reset_password") }}<br />
                    {{ $t("zurücksetzen") }}
                  </div>

                  <div class="img-box2"><img src="@/assets/images/Logo.png" class="img-responsive"></div>
                </div>
                <div class="card-body card-body2">
                  <h3 class="title">  {{ $t("Confirm_reset") }}</h3>
                  <div class="forgot-detail"> {{ $t("please_check_email") }}  </div>

                    <div class="p-t-30 btn-down">
                         <a href="/login">    <button class="btn btn--radius btn--green1" type="submit"> {{ $t("back_to_login") }}</button>
                         </a>  </div>
                </div>

            </div>

</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/login/ForgotMs.vue